import { render, staticRenderFns } from "./LanguageModal.vue?vue&type=template&id=6a9aa096&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageModal.vue?vue&type=style&index=0&id=6a9aa096&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9aa096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9aa096')) {
      api.createRecord('6a9aa096', component.options)
    } else {
      api.reload('6a9aa096', component.options)
    }
    module.hot.accept("./LanguageModal.vue?vue&type=template&id=6a9aa096&scoped=true", function () {
      api.rerender('6a9aa096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LanguageModal.vue"
export default component.exports